import { dayjs, Dayjs } from '@esg/shared';
import { genericAtom } from './jotai';

export type DateRange = [Dayjs, Dayjs];

const dateRangeStateDefault: DateRange = [
    dayjs().startOf('month'),
    dayjs().endOf('month'),
];

export const dateRangeState = genericAtom<DateRange | null>(dateRangeStateDefault);

const weekRangeStateDefault: DateRange = [
    dayjs().startOf('week'),
    dayjs().endOf('week')
];

export const weekRangeState = genericAtom<DateRange | null>(weekRangeStateDefault);